import styled from "styled-components";
import "./styles/CreateGiftCard.css";
import { useState, useEffect } from "react";
import instance from "../../axios";
import { useParams } from "react-router";
import { getUserToken } from "../../utils/userAuthenticate";
import '@splidejs/react-splide/css';
import { useTranslation } from "react-i18next";
import "../../localisation/index"

const ActiveDot = styled.div`
  width: 15px;
  height: 15px;
  margin: 0px 10px;
  border-radius: 20px;
  background: ${({ active }) => (active ? "#00dc72" : "")};
  border: 1px solid ${({ active }) => (active ? "#00dc72" : "#B62028")};
`;

const GiftCardDetail = () => {
  const {t} = useTranslation()
  const { id } = useParams();

  const [cardData, setCardData] = useState(null);
  const [mainImage, setMainImage] = useState(null)

  const updateData = async () => {
    const url = "/giftcard/products/select";
    const headers = {
      Authorization: getUserToken(),
    };
    const body = {
      product_id: id,
    };

    const res = await instance.post(url, body, { headers });
    const resData = res.data;
    ('show_barcode' in resData.data) ? setCardData(resData.data) : setCardData({...resData.data, show_barcode: false});
    setMainImage(resData.data.images[0].src)
  };

  useEffect(() => {
    updateData();
  }, []);

  const renderGiftValiditydUi=()=>{
    if(!('expiration' in cardData)){
      return (
        <div className="gift-card__validity-show">
          {cardData?.validity === 180 ? "6 {t('createGiftcard.months')}" : (cardData?.validity === 365 ? "12 {t('createGiftcard.months')}" : t("commonTexts.na"))}
        </div>
      )
    } else if('expiration' in cardData && cardData.expiration){
      return (
        <>
          <div className="gift-card__validity-radio">
            <label>
              <input type="radio" checked={'expiry_month' in cardData && cardData?.expiration} name="validity" />
              {t("createGiftcard.months")}
            </label>
            <label>
              <input type="radio" checked={'expiry_year' in cardData && cardData?.expiration} name="validity" />
              {t("createGiftcard.years")}
            </label>
            <label>
              <input type="radio" checked={!cardData?.expiration} name="validity" />
              {t("createGiftcard.noExpiry")}
            </label>
          </div>
          <div className="gift-card__validity-show">
            {`${cardData.expiry_month || cardData.expiry_year} Month${Number(cardData.expiry_month || cardData.expiry_year) > 1 ? 's' : ''}`}
          </div>
        </>
      )
    }else if('expiration' in cardData && cardData.expiration === false){
      return (
        <div className="gift-card__validity-radio">
          <label>
            <input type="radio" name="validity" />
            {t("createGiftcard.months")}
          </label>
          <label>
            <input type="radio" name="validity" />
            {t("createGiftcard.years")}
          </label>
          <label>
            <input type="radio" checked ame="validity" />
            {t("createGiftcard.noExpiry")}
          </label>
        </div>
      )
    }
  }

  return (
    cardData !== null && (
      <div className="gift-card__container section-box-container component">
        <div className="gift-card__active-status">
          {t("editGiftCard.active")} <ActiveDot active={true} />
        </div>
        <div className="gift-card__card-details">
          <div className="gift-card__card-preview">

          <div className="main-template-container">
              <div className="main-image-container">
                <img src={mainImage} alt="" />
              </div>
            </div>
          </div>

          <div className="gift-card__card-data">
            <label className="gift-card__label">{t("commonTexts.title")}</label>
            <div className="gift-card__input">{cardData?.title}</div>

            <label className="gift-card__label">{t("commonTexts.description")}</label>
            <div className="gift-card__input">{cardData?.body_html}</div>

            <label className="gift-card__label">{t("commonTexts.terms")}</label>
            <div className="gift-card__input">
              {cardData?.terms ? cardData?.terms : t("commonTexts.na")}
            </div>

            <div className="gift-card__label">
                {t("createGiftcard.GcPurchaseQuantity")}
              </div>
              <div className="gift-card__quantity-inputs">
                <label>
                  {t("createGiftcard.buyForSelfQuantity")}
                  <input
                    type="number"
                    className="gift-card__input"
                    name="self_purchase_quantity"
                    value={cardData.self_purchase_quantity}
                    onKeyDown={(e) => {
                      if (e.key === "." || e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-" ) {
                          e.preventDefault();
                      }
                    }}
                  />
                </label>
                <label>
                  {t("createGiftcard.sendAsGiftQuantity")}
                  <input
                    type="number"
                    className="gift-card__input"
                    name="gift_quantity"
                    value={cardData.gift_quantity} // Default value is 1
                    onKeyDown={(e) => {
                      if (e.key === "." || e.key === "e" || e.key === "E"|| e.key === "+" || e.key === "-" ) {
                          e.preventDefault();
                      }
                    }}
                  />
                </label>
              </div>

            <div className="barcode-checkbox">
              <input type="checkbox" name="show_barcode" checked={cardData.show_barcode} />
              <label>{t("createGiftcard.sendBarcode")}</label>
            </div>
            
            <div className="variable-denomination-container">
              <div>
                <input type="checkbox" name="variable_denomination" checked={cardData?.allow_denomination} />
                <label>{t("createGiftcard.enableDenomination")}</label>
              </div>
              {
                cardData?.allow_denomination && (
                  <div className="variable-denomination-label">
                    <label>
                      {t("createGiftcard.minValue")}
                      <input type="number" value={cardData?.min_denomination} />
                    </label>
                    <label>
                      {t("createGiftcard.maxValue")}
                      <input type="number" value={cardData?.max_denomination} />
                    </label>
                  </div>   
                )
              }
            </div>
            <div className="gift-card__label">{t("editGiftCard.gcValidity")}</div>
              { 
                  renderGiftValiditydUi()
              }
            </div>
        </div>

        <div className="gift-card__variant-data">
          <div className="gift-card__variant-grid-row">
            <label className="gift-card__label">{t("createGiftcard.variantName")}</label>
            <label className="gift-card__label">{t("createGiftcard.gcPrice")}</label>
            <label></label>
          </div>

          {cardData?.variants.map((item, index) => (
            <div className="gift-card__variant-grid-row" key={index}>
              <div className="gift-card__variant-input-title gift-card__input">
                {item.option1}
              </div>
              <div className="gift-card__variant-input-title gift-card__input">
                {item.price}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default GiftCardDetail;
